/**
 * Slice file name from start to limit
 *
 * @param str - File name
 * @param limit - Length of crop string
 * @returns Croped file name
 */
export const cropFileName = (str, limit) => str.slice(0, limit);
